import React from 'react';
import clsx from 'clsx';
import styles from './SupplierLink.module.css';

export interface SupplierLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const SupplierLink: React.FC<SupplierLinkProps> = ({ icon, className, children, ...props }) => {
  return (
    <button className={clsx(styles.supplierLink, className)} {...props}>
      {icon && <span className={styles.supplierLinkIcon}>{icon}</span>}
      {children}
    </button>
  );
};

export default SupplierLink;
